import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ErrorType } from '~/data/ErrorRecord';
import { defaultState, type Fields } from '../data/AddAutomowerState';

const slice = createSlice({
  name: 'add-robotic-mower',
  initialState: defaultState,
  reducers: {
    clearAddAutomower: () => {
      return defaultState;
    },
    toggleAddRoboticMowerModalOpen: (state) => {
      state.modalIsOpen = !state.modalIsOpen;
    },
    setPairingSuccess: (state, action: PayloadAction<Partial<Fields>>) => {
      state.error = undefined;
      state.isAdding = false;
      state.isAdded = true;
      state.addedMachine = action.payload.addedMachine;
    },
    setPairingError: (state, action: PayloadAction<ErrorType>) => {
      state.error = action.payload;
      state.isAdding = false;
      state.isAdded = false;
      state.addedMachine = undefined;
    },
    setPairingDispatched: (state) => {
      state.error = undefined;
      state.isAdding = true;
      state.isAdded = false;
      state.addedMachine = undefined;
    },
  },
});

export const {
  clearAddAutomower,
  toggleAddRoboticMowerModalOpen,
  setPairingSuccess,
  setPairingError,
  setPairingDispatched,
} = slice.actions;

export default slice.reducer;
